<template>
    <div class="profile-filter d-flex" v-if="media > 992">
        <div class="profile-filter__item" v-for="filter in filters.params">
            <label class="profile-filter__item-label">
                <input type="radio"
                       name="profile-filter"
                       :value="filter.nameValue"
                       class="profile-filter__item-input"
                       v-model="filters.value"
                       :checked="filter.checked"
                >
                <span class="profile-filter__item-mask">
            {{filter.title}}
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L5 5.5L1 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>

            </label>
        </div>
        <div class="profile-filter__item" v-if="userDataId">
            <a class="profile-filter__item-link" :href="'/volunteer/' + userDataId + '/finance-report'" target="_blank">
                {{$store.getters.t('profile_finance_report')}}
                <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L5 5.5L1 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </a>
        </div>
    </div>
    <div class="profile-filter d-flex" v-else>
        <div class="custom-select-wrapper new-select" @click="selectOpen">
            <div class="custom-select">
                <div class="custom-select__trigger">
              <span>
                  {{selectDefault.title}}
              </span>
                    <div class="arrow"></div>
                </div>
                <div class="custom-options">
                    <div class="profile-filter__item" v-for="filter in filters.params" :class="filter.checked ? 'selected' : ''" @click="getOption">
                        <label class="profile-filter__item-label">
                            <input type="radio"
                                   name="profile-filter"
                                   :value="filter.nameValue"
                                   class="profile-filter__item-input"
                                   v-model="filters.value"
                                   :checked="filter.checked"
                            >
                            <span class="profile-filter__item-mask">
                            <span class="profile-filter__item-icon" v-html="filter.icon"></span>
                                {{filter.title}}
                            </span>

                        </label>
                    </div>
                </div>
            </div>
        </div>
        <a :href="'/volunteer/' + userDataId + '/finance-report'" target="_blank" v-if="userDataId">
            {{$store.getters.t('profile_finance_report')}}
            <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L5 5.5L1 10" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </a>
    </div>
</template>

<script>
export default {
    props:['filters', 'userDataId', 'media'],
    name: "ProfileFilter",
    data(){
        return{

        }
    },

    created(){
        window.addEventListener('click', this.selectClose)
    },

    destroyed(){
        window.removeEventListener('click', this.selectClose)
    },

    mounted(){
    },

    computed:{
        selectDefault(){

            let result = this.filters;

            if (this.filters.value){
                result = result.params.find(filter => {
                    return filter.nameValue === this.filters.value
                })
            }

            return result
        },
    },

    methods: {

        selectOpen(){

            let customSelect = document.querySelector('.new-select .custom-select')
            customSelect.classList.toggle('open')

        },

        getOption(){
            let options = document.querySelectorAll('.new-select .profile-filter__item')

            for (const option of options) {
                option.addEventListener('click', function() {
                    if (!this.classList.contains('selected')) {
                        this.parentNode.querySelector('.profile-filter__item.selected').classList.remove('selected');
                        this.classList.add('selected');
                        this.closest('.custom-select').querySelector('.custom-select__trigger span').innerHTML = this.querySelector('.profile-filter__item-mask').innerHTML;

                        setTimeout(()=>{
                            this.closest('.custom-select').classList.remove('open')
                        }, 300)
                    }

                })
            }
        },

        selectClose(e){

            if(this.media > 992) return

            let select = document.querySelector('.custom-select');

            if(!select.contains(e.target)){

                select.classList.remove('open')

            }

        }
    }
}
</script>

<style lang="scss" scoped>
@import '../../../sass/helpers';

.profile-filter{
    flex-direction: column;
    margin-bottom: 32px;
    background: #fff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    overflow: hidden;

    &__item{

        &-label{
            display: block;
            position: relative;
            margin-bottom: 0;
            cursor: pointer;

        }

        &-input{
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }

        &-mask, &-link{
            position: relative;
            display: block;
            color: inherit;
            padding: 22px 30px 22px 20px;
            border-bottom: 1px solid #ECECEC;
            transition: background .2s ease, color .2s ease,opacity .2s ease;
            svg{
                position: absolute;
                right: 20px;

                top: 50%;

                transform: translateY(-50%);

            }

            &:hover{
                opacity: .8;
            }

        }

        &-input[type='radio']:checked ~ .profile-filter__item-mask{
            color: #fff;
            background: $primaryBlue;

            &:hover{
                opacity: 1;
            }
        }


        &:last-child{
            .profile-filter__item-mask{
                border-bottom: none;
            }
        }
    }


    .custom-select-wrapper {
        position: relative;
        user-select: none;

        width: 300px;
    }
    .custom-select {
        position: relative;
        padding: 0;
        background: transparent;
        height: auto;
        display: flex;
        flex-direction: column;
        box-shadow: none;
        width: 100%;
        margin: 0 auto;
        border: none;


        .profile-filter__item-mask{
            position: relative;
            padding: 0 32px;
            line-height: 40px;
            height: 40px;
            font-size: 12px;

            .profile-filter__item-icon{
                position: absolute;

                left: 15px;
                top: 50%;

                transform: translateY(-50%);
            }

        }



    }
    .custom-select__trigger {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 22px 0 32px;
        font-size: 12px;
        font-weight: 300;
        color: #3b3b3b;
        height: 40px;
        line-height: 40px;
        background: #ffffff;
        cursor: pointer;
        border-radius: 10px;
        border: 1px solid #929292;

        .profile-filter__item-icon{
            position: absolute;

            left: 15px;
            top: 50%;

            transform: translateY(-50%);
        }

    }
    .custom-options {
        position: absolute;
        display: block;
        top: 100%;
        left: 0;
        right: 0;
        border: 1px solid #929292;
        border-top: 0;
        background: #fff;
        transition: all 0.5s;
        opacity: 0;
        visibility: hidden;
        pointer-events: none;
        z-index: 3;

        .profile-filter__item-input{
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            z-index: 1;
            pointer-events: all;
        }

        .profile-filter__item-mask{
            pointer-events: none;
        }
    }

    .custom-select.open{
        height: auto;
    }

    .custom-select.open .custom-options {
        opacity: 1;
        visibility: visible;
        pointer-events: all;
    }
    .custom-option {
        position: relative;
        display: block;
        padding: 0 22px 0 22px;
        font-size: 22px;
        font-weight: 300;
        color: #3b3b3b;
        line-height: 60px;
        cursor: pointer;
        transition: all 0.5s;
    }
    .custom-option:hover {
        cursor: pointer;
        background-color: #b2b2b2;
    }
    .custom-option.selected {
        color: #ffffff;
        background-color: #305c91;
    }

    .arrow {
        position: relative;
        height: 10px;
        width: 10px;
    }
    .arrow::before, .arrow::after {
        content: "";
        position: absolute;
        bottom: 0px;
        width: 0.15rem;
        height: 100%;
        transition: all 0.5s;
    }
    .arrow::before {
        left: -3px;
        transform: rotate(45deg);
        background-color: #394a6d;
    }
    .arrow::after {
        left: 3px;
        transform: rotate(-45deg);
        background-color: #394a6d;
    }
    .open .arrow::before {
        left: -3px;
        transform: rotate(-45deg);
    }
    .open .arrow::after {
        left: 3px;
        transform: rotate(45deg);
    }


}

@media screen and (max-width: 992px){
    .profile-filter{
        background: transparent;
        align-items: center;
        box-shadow: none;
        overflow: visible;
        flex-flow: row nowrap;
        justify-content: space-between;
    }
}

@media screen and (max-width: 500px){
    .profile-filter{
        flex-direction: column-reverse;
        justify-content: center;

    }
    .profile-filter .custom-select-wrapper{
        width: 100%;
        margin-top: 15px;
    }

}

</style>
